import { default as React } from "react";
import { SvgIconProps, SvgIcon } from "@material-ui/core";

export default (props: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 33 34" {...props} height="178.14" width="178.14">
      <defs>
        <style>
          {
            ".cls-1{isolation:isolate;}.cls-2{opacity:0.58;mix-blend-mode:multiply;}.cls-3{fill:#f25f5c;}.cls-4{fill:#f28c8a;}.cls-5{fill:#fafafa;}"
          }
        </style>
      </defs>
      <title>slide2 (no background)</title>
      <g className="cls-1">
        <g id="Layer_1" data-name="Layer 1">
          <g id="icn_add" data-name="icn add">
            <image
              className="cls-2"
              width="33"
              height="34"
              xlinkHref="data:image/png;base64,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"
            />
            <path
              id="Path_20-2"
              data-name="Path 20-2"
              className="cls-3"
              d="M11.75,1.5A10.37,10.37,0,0,1,22,12,10.37,10.37,0,0,1,11.75,22.47,10.37,10.37,0,0,1,1.5,12h0A10.37,10.37,0,0,1,11.75,1.5Z"
              transform="translate(5 3)"
            />
            <g id="Group_12" data-name="Group 12">
              <path
                id="Path_18"
                data-name="Path 18"
                className="cls-4"
                d="M16.79,11.71,11.86,6.82a.28.28,0,0,0-.38,0h0l-4.78,5a.29.29,0,0,0,0,.39h0l4.93,4.89a.34.34,0,0,0,.19.09.23.23,0,0,0,.19-.09l4.78-5a.27.27,0,0,0,.08-.19A.22.22,0,0,0,16.79,11.71Zm-5,4.87L7.25,12.06l4.42-4.67,4.57,4.52Z"
                transform="translate(5 3)"
              />
              <path
                id="Path_19"
                data-name="Path 19"
                className="cls-5"
                d="M11.48,10.16V11.5H10.17a.26.26,0,0,0-.25.26.28.28,0,0,0,.25.25h1.31v1.32a.27.27,0,0,0,.26.26.28.28,0,0,0,.25-.26V12h1.29a.26.26,0,0,0,.25-.26.24.24,0,0,0-.22-.26H12V10.16a.26.26,0,0,0-.25-.26A.31.31,0,0,0,11.48,10.16Z"
                transform="translate(5 3)"
              />
            </g>
          </g>
        </g>
      </g>
    </SvgIcon>
  );
};
